import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ContentService } from '../_core';
import { LcpHelper } from '../_core/_helpers/lcp-helper';
// import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

@Component({
  selector: 'lcp-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss']
})
export class TeamComponent implements OnInit {
  
  slug = 'team'
  content: any
  fields: any

  slideCount = 8; // - see carousel.component.css 
  

  constructor(
    private cdr: ChangeDetectorRef, 
    public contentService: ContentService,
    public lcpHelper: LcpHelper
  ) { }

  ngOnInit(): void {
    this.getPage()
  }

  getPage(){
    // this.contentService.getPage({'fields.slug': 'home', 'fields.version': 2 })
    this.contentService.getPage({'fields.slug': this.slug })
    .subscribe({
        next: (content) => {
          this.content = content
          if (!this.content) return console.log('!content', this.content)
          this.fields = this.content.items[0].fields
          this.detectChanges()
          // console.log('fields', this.fields);
        }
    });
  }

  itemPhoto(item: any, index: number) {
    let url
    try {
      url = item.fields['media'][index].fields.file.url
    } catch { 
      return 
    }
    let src = 'https:' + url
    return src
  }

  itemFirstPhoto(item: any) {
  // employeePhoto(employee: any) {
    let url
    try {
      url = item.fields['media'][0].fields.file.url
    } catch { 
      return 
    }
    let src = 'https:' + url
    return src
  }

  handleCarouselInit(evt: any) {
    // console.log('TODO: handleCarouselInit', evt)
    this.slideCount = evt
    this.detectChanges()
  }

  detectChanges() {
    if (!this.cdr['destroyed']) this.cdr.detectChanges()
  }

}
